import {useMemo} from "react";
import {useSelector} from "react-redux";

export default () => {

	const {org} = useSelector(store => store);

	return useMemo(() => {
		return {
			...org
		};
	}, [org]);

};
